module.exports = __webpack_public_path__ + "static/compsci-1-4cc6a399a2bd09aded8d4a04e4910018.jpg";